import http from "../../http";

/** 地址规则 — /resident/api/resident/houseAddressRule */
const BASE = "/resident/api/resident/houseAddressRule";

const addressRule = {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectList(r) {
    return http.get(`${BASE}/list`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
  updateSortNo(r) {
    return http.tip.post(`${BASE}/updateSortNo`, r);
  },
  delete(r) {
    return http.confirm.post(`${BASE}/delete`, r);
  },
};

export default addressRule;
